<template>
  <div>
    <div class="hsec">
      <div class="row top">
        <div class="col header-text">
          <div class="pre-header"></div>
          <h1>{{ $t('views.referral.inviteAFriend') }}<br><span class="blue">{{ $t('views.referral.earnMoney') }}</span>{{ $t('views.referral.forBoth') }}</h1>
          <h3><p>{{ $t('views.referral.ifYouLike') }}</p></h3>
          <div class="d-flex mt-4">
            <button id="copy" class="btn income-btn refer-btn btn-secondary" v-if="this.shareLink"
                    v-clipboard="this.shareLink"
                    v-clipboard:success="clipboardSuccessHandler"
                    v-clipboard:error="clipboardErrorHandler">{{ $t('views.referral.inviteAFriend1') }}<b-tooltip target="copy" triggers="hover">{{ $t('views.referral.copyReferralLink') }}</b-tooltip>
              <b-tooltip target="copy" triggers="click">{{ $t('views.referral.referralLinkIs') }}</b-tooltip>
            </button>
          </div>
        </div>
        <div class="col top-block">
        </div>
      </div>
    </div>
    <div class="container invite-container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h3 class="invite-container-heading earn-heading">{{ $t('views.referral.earnUpTo') }}</h3>
          <p class="earn-text">{{ $t('views.referral.incomeIsWorking') }}</p>
          <div class="invitation-section" v-if="shareCode">
            <b-alert variant="success" show v-if="invitationSuccess">{{invitationSuccess}}</b-alert>
            <b-alert variant="warning" show v-if="invitationFailed">{{invitationFailed}}</b-alert>
            <b-input-group>
              <b-form-input class="invitation-input" type="email" v-model="friendsEmail" placeholder="Friend`s email"></b-form-input>
              <b-input-group-append>
                <b-button class="income-btn invitation-btn" :disabled="!friendsEmail" @click="sendInvitation()">Send invitation</b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>
        <div class="col-lg-12 invite-schema">
          <img v-bind:src="getSrc($t('views.referral.inviteSchemaImg'))" alt="" class="w-100"/>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <h3 class="text-center bonus-heading">{{ $t('views.referral.bonusForFriends') }}</h3>
          <div class="border-container">
            <div class="row">
              <div class="col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3">
                <p>{{ $t('views.referral.wePayYou') }}</p>
                <p>{{ $t('views.referral.weAlsoPay') }}</p>
                <p>{{ $t('views.referral.theBonusIs') }}</p>
                <div class="noteDetails">
                  <p>{{ $t('views.referral.noteDetails1') }}</p>
                  <p>{{ $t('views.referral.noteDetails2') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container invite-section" id="share">
      <div class="invite-image">
        <img alt="" src="../assets/invite-image.jpg">
      </div>
      <div class="invite-content">
        <h3><span class="blue">{{ $t('views.referral.share') }}</span>{{ $t('views.referral.yourReferralLink') }}</h3>
        <b-input
            v-model="shareLink"
            class="income-btn share-input" v-if="shareLink"
            onClick="this.setSelectionRange(0, this.value.length)"
            @change="revertShareLink()"
            id="copyinput"
            v-clipboard="this.shareLink"
            v-clipboard:success="clipboardSuccessHandler"
            v-clipboard:error="clipboardErrorHandler"
        >
        </b-input>
        <b-tooltip target="copyinput" triggers="hover" v-if="shareLink">{{ $t('views.referral.copyReferralLink1') }}</b-tooltip>
        <b-tooltip target="copyinput" triggers="click" v-if="shareLink">{{ $t('views.referral.referralLinkIs1') }}</b-tooltip>
        <div v-if="shareCode"><h3>{{ $t('views.referral.or') }} <span class="blue">{{ $t('views.referral.referralCode') }}</span></h3>
          <b-input
              v-model="shareCode"
              class="income-btn share-input" v-if="shareCode"
              onClick="this.setSelectionRange(0, this.value.length)"
              @change="revertShareCode()"
              id="copycodeinput"
              v-clipboard="this.shareCode"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
          ></b-input>
          <b-tooltip target="copycodeinput" triggers="hover" v-if="shareCode">{{ $t('views.referral.copyReferralCode') }}</b-tooltip>
          <b-tooltip target="copycodeinput" triggers="click" v-if="shareCode">{{ $t('views.referral.referralCodeIs') }}</b-tooltip>
        </div>
        <b-button class="income-btn share-link" v-if="!shareLink" :to="btnLink">{{btnText}}</b-button>
        <div class="invitation-section" v-if="shareCode" style="margin-top: 30px;">
          <b-alert variant="success" show v-if="invitationSuccess">{{invitationSuccess}}</b-alert>
          <b-alert variant="warning" show v-if="invitationFailed">{{invitationFailed}}</b-alert>
          <b-input-group>
            <b-form-input class="invitation-input" type="email" v-model="friendsEmail" placeholder="Friend`s email"></b-form-input>
            <b-input-group-append>
              <b-button class="income-btn invitation-btn" :disabled="!friendsEmail" @click="sendInvitation()">Send invitation</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <p class="terms-link">
          <router-link :to="$t('router.links.referralProgram')">{{ $t('views.referral.terms') }}</router-link>
        </p>
      </div>
    </div>
    <div class="container">
      <div class="row founded">
        <div class="col-12 col-md-6 col-lg-6 col-xl-6">
          <div class="left-section">
            <div class="our-promise">
              <h2><span class="blue">{{ $t('views.referral.foundedIn') }}</span>{{ $t('views.referral.weAreBringing') }}</h2>
              <div>
                <div class="description"><span class="blue">{{ $t('views.referral.watch') }}</span>{{ $t('views.referral.ourIntroductoryVideo') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-6 col-xl-6">
          <div>
            <promo-video-schema></promo-video-schema>
            <video width="100%" height="300" preload="none" controls="controls" poster="../assets/video/video_preview.png" onclick="this.play()">
              <source src="../assets/video/get_income.mp4" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>{{ $t('views.referral.videoIsNot') }}<a href="../assets/video/get_income.mp4"></a>.
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from 'v-clipboard'
import Vue from 'vue'
import imageMixin from '@/mixins/image'
import investorStatuses, {registrationStatuses} from '@/config/investorStatuses'
import PromoVideoSchema from '@/schema/PromoVideoSchema'

Vue.use(Clipboard)

export default {
  name: 'Referral',
  components: {PromoVideoSchema},
  mixins: [imageMixin],
  data()
  {
    return {
      investor: this.$store.state.investors.investor,
      shareLink: '',
      shareCode: '',
      btnText: this.$t('views.invite.registerNowBtnText'),
      btnLink: 'register-complete',
      friendsEmail: '',
      invitationSuccess: '',
      invitationFailed: ''
    }
  },
  created()
  {
    // refresh investor info because open in new window/tab
    if (this.$auth?.accessToken) {
      this.$store.dispatch('investors/fetchUserInvestor')
    }
  },
  watch: {
    '$store.state.investors.investor':
        {
          handler(investor)
          {
            if (investor)
            {
                if (registrationStatuses.includes(investor.investor_account_status))
                {
                  this.btnText = 'Complete registration to see your own unique code'
                }
                else if (investor.investor_account_status === investorStatuses.PENDING)
                {
                  this.btnLink = 'account'
                  this.btnText = 'We are now verifying your information and will let you know soon your own unique code'
                }
                else if (investor.investor_account_status === investorStatuses.DECLINED)
                {
                  this.btnLink = 'account'
                  this.btnText = 'Code not available due to inactive account. Please contact Investor care.'
                }
                else if (investor.investor_invitation_code_to_share)
                {
                  this.shareLink = 'https://getincome.com/register?ref_code=' + this.$store.state.investors.investor.investor_invitation_code_to_share
                  this.shareCode = this.$store.state.investors.investor.investor_invitation_code_to_share
                } else {
                  this.btnLink = 'account'
                  this.btnText = 'Invitation code to share not found.'
                }
            }
          },
          deep: true,
          immediate: true
        }
  },
  methods:
      {
        revertShareLink()
        {
          this.shareLink = 'https://getincome.com/register?ref_code=' + this.$store.state.investors.investor.investor_invitation_code_to_share
        },
        revertShareCode()
        {
          this.shareCode = this.$store.state.investors.investor.investor_invitation_code_to_share
        },
        clipboardSuccessHandler({value, event})
        {
          setTimeout(() =>
          {
            this.$root.$emit('bv::hide::tooltip', event.target.id)
          }, 1500)
        },
        clipboardErrorHandler({value, event})
        {
          console.error('Something wrong with copy from clipboard', value)
        },
        sendInvitation()
        {
          this.invitationSuccess = this.invitationFailed = ''
          // TODO valid email
          // this.friendsEmail
          const axios = require('axios').default
          axios.post(process.env.VUE_APP_API_BASE_URL + 'refer-a-friend', {email: this.friendsEmail})
              .then((response) =>
              {
                  this.invitationSuccess = response.data.message
              }
          ).catch((error) =>
          {
            if (error.response.data && error.response.data.message)
            {
              this.invitationFailed = error.response.data.message
            }
            console.error(error)
          })
        }
      }
}
</script>

<style scoped lang="scss">
.share-link{
  max-height: none;
  margin: 15px;
}

.invitation-section{
  text-align: center;
  display: inline-block;
}
.invitation-input{
  border-radius: 24px 24px;
}
.invitation-btn{
  background: #30A7FE;
  color: #fff;
  border-radius: 0 24px 24px 0;
}

.hsec {
  .top {
    border-bottom: 1px solid #c3c3c3;
    margin-bottom: 10px;
  }
}

.header-text {
  text-align: left;
  margin: 82px auto 48px 10%;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 64px;
    text-align: left;
    color: #000000;
    flex: none;
    max-width: 725px;
    margin: auto 0 15px;

    .blue {
      color: #30A7FE;
    }
  }

  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    text-align: left;
    color: #6E777A !important;
    flex: none;
    order: 2;
    //align-self: center;
    //margin: auto auto 16px;
    max-width: 826px;

    p {
      margin-top: 24px;
    }
  }

  .pre-header {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    color: #9DA0A6;
    flex: none;
    order: 0;
    align-self: center;
    margin: 0 0 10px;
  }

  .refer-btn {
    min-width: 280px;
    padding: 12px 10px;
  }
}

.top-block {
  background-image: url("../assets/refer-top-bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center left;
}

.home-start-investing {
  text-align: center;
  margin-top: 80px;
  margin-bottom: 100px;
  font-style: normal;

  h2 {
    font-size: 36px;
    line-height: 40px;
    font-weight: bold;
    color: #000000;
  }

  .detail-info {
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    color: #9DA0A6;
  }
}

.invite-schema {
  display: flex;
  justify-content: center;
  margin-top: 80px;
}

.invite-container {
  padding: 80px 0;

  &-heading {
    margin-bottom: 60px;
  }
}

.border-container {
  padding: 24px 0 12px;
  margin: 24px 0;
  border-top: 1px solid #6E777A;
  border-bottom: 1px solid #6E777A;

  p {
    color: #6E777A;
    font-size: 18px;
    line-height: 24px;
  }
}

.invite-section {
  display: flex;
  align-items: stretch;
  margin-top: 80px;
  margin-bottom: 80px;
  border: 1px solid #D6D6D6;
  border-radius: 4px;
  padding: 0;

  .invite-image {
    flex: 0 0 45%;

    img {
      width: 100%;
    }
  }

  .invite-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 0 0 55%;
    background-color: #FFFFFF;

    h3 {
      font-size: 36px;
      font-weight: bold;
      line-height: 40px;
    }

    p {
      margin-top: 40px;
      font-size: 24px;
      font-weight: bold;
    }
  }
}

.earn-heading {
  font-weight: 700;
  font-size: 36px;

  .earn-text {
    font-weight: 400;
  }
}

.earn-text {
  color: #6E777A;
  font-size: 16px;
}

.bonus-heading {
  font-weight: 700;
  font-size: 24px;
}

.founded {
  margin-top: 50px;
  margin-bottom: 50px;

  .left-section {
    .our-promise {
      h2 {
        font-weight: bold;
        font-size: 35px;
        line-height: 40px;
        margin-top: 15px;
      }

      .description {
        font-size: 16px;
        line-height: 24px;
        color: #6E777A;
        margin-top: 50px;
      }
    }
  }
}

@media only screen and (min-width: 1250px) {
  .top-block {
    background-size: cover;
    background-position: top;
  }
}
@media only screen and (max-width: 992px) {
  .invite-section {
    .invite-content {
      padding: 12px;

      h3 {
        font-size: 24px;
      }

      p {
        font-size: 14px;
      }
    }
  }
}

@media only screen and (max-width: 720px) {
  .invite-section {
    display: block;

    .invite-image {
      display: none;
    }

    .invite-content {
      text-align: center;

      p {
        margin-top: 12px;
      }
    }
  }
}

@media only screen and (min-width: 320px) and (max-width: 480px) {
  .top-block {
    display: none;
  }
  .header-text {
    margin: 82px auto 16px 10%;
  }
}

.mobile {
  margin-top: 25px;
  margin-bottom: 0;
}

.terms-link {
  text-transform: uppercase;

  a {
    color: #30A7FE;
    text-decoration: underline;
  }
}

.share-input {
  max-width: 440px;
  text-align: center;
  color: #30A7FE;
  font-size: 15px;
  /*text-decoration: underline;*/
  font-weight: bold;
}

.noteDetails{
  p{
    margin-bottom: 5px;
    font-size: 11px;
    line-height: 14px;
  }
}
</style>
